import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";
import { traductionsKeysEnum } from 'src/assets/i18n/traductionsKeysEnum';

@Component({
   selector: 'app-editable-input',
   templateUrl: './editable-input.component.html',
   styleUrls: ['./editable-input.component.scss'],
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => EditableInputComponent),
      }
   ]
})
export class EditableInputComponent implements ControlValueAccessor {
   @Input() formControlName: string;
   @Input() updateValue: any;
   @Output() updatedValue = new EventEmitter();
   form: FormGroup;
   editMode = false;

   @Input() displayValue: any;
   // eslint-disable-next-line @typescript-eslint/no-empty-function
   onTouched: any = () => {
   };
   // eslint-disable-next-line @typescript-eslint/no-empty-function
   onChange: any = () => {
   };

   writeValue(value: any): void {
      this.updateValue = value;
   }

   registerOnChange(fn: any): void {
      this.onChange = fn;
   }

   registerOnTouched(fn: any): void {
      this.onTouched = fn;
   }

   onConfirm(event): void {
      event.stopPropagation();
      this.editMode = false;
      this.onTouched();
      this.updatedValue.emit({ label: this.formControlName, value: this.updateValue });
      // console.log('update value', this.updateValue);
      // const updateValue = this.displayValue$.value.replace(/(\/)(\d+|.{3}|.*?)(s)?/g, (match, slash, number, s) => `${slash}${this.updateValue}${s || ''}`);
      // console.log('update value 2', updateValue);
      // this.displayValue$.next(updateValue);
      // console.log('display value', this.displayValue$.value);
   }

   toggleEditMode() {
      this.editMode = !this.editMode;
   }

   cancelEdit() {
      this.editMode = false;
   }

   onInputBlur(event: Event) {
      this.updateValue = (event.target as HTMLInputElement).value;
      this.onChange(this.updateValue);
      this.onTouched();
   }

     protected readonly traductionsKeysEnum = traductionsKeysEnum;

}
